import { BadgeBlock, ButtonBlock, DividerBlock, GroupBlock, HeadingBlock, ImageBlock, SectionBlock, SpacerBlock, TextBlock } from './primitives';
import {
  BadgeBlockFields,
  ButtonBlockFields,
  DividerBlockFields,
  GroupBlockFields,
  HeadingBlockFields,
  ImageBlockFields,
  SectionBlockFields,
  SpacerBlockFields,
  TextBlockFields,
} from "./primitives.fields";
import type { BadgeBlockProps, ButtonBlockProps, DividerBlockProps, GroupBlockProps, HeadingBlockProps, ImageBlockProps, SectionBlockProps, SpacerBlockProps, TextBlockProps } from './primitives';
import type { ComponentConfig } from "@puckeditor/core";
import { ImagePicker } from "../editor/ImagePicker";

const BadgeBlockConfig: ComponentConfig<BadgeBlockProps> = {
    defaultProps: {
      align: "left",
      icon: "",
      size: "medium",
      spacing: "tight",
      text: "Licensed & Insured",
      tone: "accent",
    },
    fields: BadgeBlockFields as never,
    label: "Badge",
    render: ({ id, ...props }) => <BadgeBlock id={id} {...props} />,
  },

  ButtonBlockConfig: ComponentConfig<ButtonBlockProps> = {
    defaultProps: {
      align: "left",
      label: "Get a Quote",
      size: "medium",
      spacing: "normal",
      url: "#contact",
      variant: "primary",
    },
    fields: {
      ...ButtonBlockFields,
      label: { ...ButtonBlockFields.label, contentEditable: true },
    } as never,
    label: "Button",
    render: ({ id, ...props }) => <ButtonBlock id={id} {...props} />,
  },

  DividerBlockConfig: ComponentConfig<DividerBlockProps> = {
    defaultProps: { spacing: "normal", width: "normal" },
    fields: DividerBlockFields as never,
    label: "Divider",
    render: ({ id, ...props }) => <DividerBlock id={id} {...props} />,
  },

  GroupBlockConfig: ComponentConfig<GroupBlockProps> = {
    defaultProps: {
      align: "left",
      content: [],
      direction: "row",
      gap: "normal",
      spacing: "tight",
      wrap: "yes",
    } as never,
    fields: GroupBlockFields as never,
    label: "Group",
    render: ({ id, ...props }) => <GroupBlock id={id} {...props} />,
  },

  HeadingBlockConfig: ComponentConfig<HeadingBlockProps> = {
    defaultProps: {
      align: "left",
      color: "auto",
      level: "h2",
      size: "medium",
      spacing: "normal",
      text: "Your heading",
      width: "normal",
    },
    fields: {
      ...HeadingBlockFields,
      text: { ...HeadingBlockFields.text, contentEditable: true },
    } as never,
    label: "Heading",
    render: ({ id, ...props }) => <HeadingBlock id={id} {...props} />,
  },

  ImageBlockConfig: ComponentConfig<ImageBlockProps> = {
    defaultProps: {
      align: "center",
      alt: "",
      caption: "",
      frame: "none",
      imageUrl: "",
      spacing: "normal",
      width: "normal",
    },
    fields: {
      ...ImageBlockFields,
      caption: { ...ImageBlockFields.caption, contentEditable: true },
      imageUrl: {
        ...ImageBlockFields.imageUrl,
        render: ({
          value,
          onChange,
        }: {
          value?: string;
          onChange: (val: string | undefined) => void;
        }) => <ImagePicker value={value || ""} onChange={onChange} label="Image" />,
      },
    } as never,
    label: "Image",
    render: ({ id, ...props }) => <ImageBlock id={id} {...props} />,
  },

  SectionBlockConfig: ComponentConfig<SectionBlockProps> = {
    defaultProps: {
      anchorId: "",
      background: "default",
      content: [],
      padding: "normal",
    } as never,
    fields: SectionBlockFields,
    label: "Section",
    render: ({ id, ...props }) => <SectionBlock id={id} {...props} />,
  },

  SpacerBlockConfig: ComponentConfig<SpacerBlockProps> = {
    defaultProps: { height: "medium" },
    fields: SpacerBlockFields,
    label: "Spacer",
    render: ({ id, ...props }) => <SpacerBlock id={id} {...props} />,
  },

  TextBlockConfig: ComponentConfig<TextBlockProps> = {
    defaultProps: {
      align: "left",
      color: "auto",
      content: "Add your text here. Separate paragraphs with a blank line.",
      size: "medium",
      spacing: "normal",
      width: "narrow",
    },
    fields: {
      ...TextBlockFields,
      content: { ...TextBlockFields.content, contentEditable: true },
    } as never,
    label: "Text",
    render: ({ id, ...props }) => <TextBlock id={id} {...props} />,
  };

export {
  HeadingBlockConfig,
  TextBlockConfig,
  ButtonBlockConfig,
  ImageBlockConfig,
  SpacerBlockConfig,
  DividerBlockConfig,
  SectionBlockConfig,
  BadgeBlockConfig,
  GroupBlockConfig,
};
